export enum PlanningExcelVersion {
  V1 = 'v1',
  V2 = 'v2',
}
